{
    "table_header__product_name": "Artikel",
    "table_header__quote_id": "Angebot ID",
    "table_header__order_id": "Auftrag ID",
    "table_header__customer_id": "Kunden ID",
    "table_header__customer": "Kunde",
    "table_header__quote_created": "Datum",
    "table_header__valid_until": "Gültig bis",
    "table_header__offer": "Angebot",
    "table_header__status": "Status",
    "table_header__order_date": "Datum",
    "table_header__location": "Standort",
    "table_header__quantity": "Menge geliefert",
    "table_header__total": "Summe",
    "table_header__margin": "DB",
    "table_header__unit": "Einheit",
    "table_header__price": "Preis",
    "table_header__lines": "Zeilen",
    "table_header__sales_rep": "Erfasser",
    "table_header__clerk": "Erfasser"
}
